/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * dogma_attribute object
 * @export
 * @interface GetUniverseTypesTypeIdDogmaAttribute
 */
export interface GetUniverseTypesTypeIdDogmaAttribute {
    /**
     * attribute_id integer
     * @type {number}
     * @memberof GetUniverseTypesTypeIdDogmaAttribute
     */
    attributeId: number;
    /**
     * value number
     * @type {number}
     * @memberof GetUniverseTypesTypeIdDogmaAttribute
     */
    value: number;
}

/**
 * Check if a given object implements the GetUniverseTypesTypeIdDogmaAttribute interface.
 */
export function instanceOfGetUniverseTypesTypeIdDogmaAttribute(value: object): value is GetUniverseTypesTypeIdDogmaAttribute {
    if (!('attributeId' in value) || value['attributeId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetUniverseTypesTypeIdDogmaAttributeFromJSON(json: any): GetUniverseTypesTypeIdDogmaAttribute {
    return GetUniverseTypesTypeIdDogmaAttributeFromJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdDogmaAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseTypesTypeIdDogmaAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeId': json['attribute_id'],
        'value': json['value'],
    };
}

export function GetUniverseTypesTypeIdDogmaAttributeToJSON(json: any): GetUniverseTypesTypeIdDogmaAttribute {
    return GetUniverseTypesTypeIdDogmaAttributeToJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdDogmaAttributeToJSONTyped(value?: GetUniverseTypesTypeIdDogmaAttribute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attribute_id': value['attributeId'],
        'value': value['value'],
    };
}

